'use strict';
class PromoStrip {
    init () {
        const _self = this;
        _self.initialPaddingTop = parseFloat($('.page').css('padding-top'));
        _self.initStripSlider();

        $(document).on('click touchend', '.cc-promoStrip .js-closePromoStrip', function (e) {
            e.preventDefault();
            const pageElement = $('.page');
            $(this).closest('.cc-promoStrip').slideUp(300);
            let initialPagePaddingTop = _self.initialPaddingTop; // parseFloat($(pageElement).css('padding-top'));
            // $(pageElement).removeAttr('style');
            $(pageElement).animate({'padding-top': initialPagePaddingTop + 'px'}, 300, () => {
                var element = document.getElementsByClassName('js-subHeaderMobile');
                var root = document.querySelector(':root');
                root.style.setProperty('--main-header', element[0].offsetHeight + 'px');
                if (element.length > 0) {
                    $(element).addClass('cc-moreTopSpacing');
                }
            });
        });
    }

    initStripSlider () {
        let maxHeight = -1;
        let pagePaddingTop = this.initialPaddingTop;
        const pageElement = $('.page');

        if ($('.cc-promoStrip').length > 0) {
            const promoStripElement = $('.cc-promoStrip');

            $(promoStripElement).find('.slick-slide').each(function () {
                $(this).find('.cc-promoStrip__slide__wrp').removeAttr('style');
                if ($(this).find('.cc-promoStrip__slide__wrp').outerHeight() > maxHeight) {
                    maxHeight = $(this).find('.cc-promoStrip__slide__wrp').outerHeight();
                }
            });
            $(promoStripElement).find('.slick-slide').each(function () {
                $(this).find('.cc-promoStrip__slide__wrp').css('height', maxHeight);
            });

            if ($('header.js-mainHeader-container').css('position') === 'relative') {
                return;
            }

            $(pageElement).css('padding-top', pagePaddingTop + maxHeight + 'px');
        }
    }
}

const promoStrip = new PromoStrip();
export default promoStrip;
